var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"ml-2",attrs:{"size":"10","color":_vm.isSuccess ? 'success500' : '#C1C1C1'}},[_vm._v("$yzi-gift-02")])}
var staticRenderFns = []

export { render, staticRenderFns }